<template>
    <v-dialog v-model="dialog" persistent max-width="1200">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>{{$t('core.showdialog.description')}} {{type}}: {{ name }} ?</v-card-text>
        <v-container class="py-0">
            <v-row>
              <v-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                <ckeditor
                 editor="ClassicEditor"
                 :config="editorConfig"
                 id="editor2"
                 name="workflowDescription"
                 v-model= detailText
                />
              </v-col>
            </v-row>
          </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="$emit('Cancel')">{{$t('button.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue'
import CKEditor from 'ckeditor4-vue'

Vue.use(CKEditor)

export default {
  name: 'ShowDialog',

  props: ['dialog', 'name', 'type', 'detailText'],

  data () {
    return {
      editorConfig: {
        toolbarGroups: [{
          name: 'basicstyles',
          groups: ['basicstyles']
        },
        {
          name: 'links',
          groups: ['links']
        },
        {
          name: 'paragraph',
          groups: ['list', 'blocks', '-', 'JustifyLeft']
        },
        {
          name: 'document',
          groups: ['mode']
        },
        {
          name: 'insert',
          groups: ['insert']
        },
        {
          name: 'styles',
          groups: ['styles']
        },
        {
          name: 'about',
          groups: ['about']
        }
        ],
        removeButtons: 'Strike,Subscript,Superscript,Anchor,Styles,Specialchar,PasteFromWord',
        readOnly: true,
        extraPlugins: 'justify'
      }
    }
  }
}
</script>
